import React from "react";
import TrackIDView from "./TrackIDView";
import TrackResizer from "./TrackResizer";
import Timeblocks from "./Timeblocks";
import Events from "./Events";
import {} from "../redux/actions";
import { selectWeekCount } from "../redux/selectors";
import { connect } from "react-redux";

class Track extends React.Component {
    state = {
        dragTimeBlockIndex: false,
        dragTimeBlockRow: false,
        isDragging: false,
        eventIndex: false,
        eventRow: false
    };
    render() {
        const timeblocksStyle = {
            gridTemplateRows: `repeat(${this.props.overlaps}, auto)`,
            gridTemplateColumns: `repeat(${this.props.weekCount * 7}, auto)`
        };

        return (
            <TrackResizer
                id={this.props.id}
                parentTrackIndex={this.props.parentTrackIndex}
                childTrackIndex={this.props.childTrackIndex}
            >
                <div
                    className={`TrackContainer TrackContainer-${
                        this.props.type === "jobpack" ? "parent" : "child"
                    }`}
                >
                    <TrackIDView
                        type={this.props.type}
                        name={this.props.name}
                        setShowChildren={this.props.setShowChildren}
                        parentTrackIndex={this.props.parentTrackIndex}
                        childTrackIndex={this.props.childTrackIndex}
                        showChildren={this.props.showChildren}
                    />
                    <div className="Timeblocks" style={timeblocksStyle}>
                        <Timeblocks
                            rows={this.props.overlaps}
                            parentTrackIndex={this.props.parentTrackIndex}
                            childTrackIndex={this.props.childTrackIndex}
                            weekCount={this.props.weekCount}
                            setEventPosition={(
                                timeBlockIndex,
                                timeBlockRow
                            ) => {
                                if (
                                    this.state.isDragging === true &&
                                    (timeBlockIndex !==
                                        this.state.dragTimeBlockIndex ||
                                        timeBlockRow !==
                                            this.state.dragTimeBlockRow)
                                ) {
                                    this.setState({
                                        ...this.state,
                                        dragTimeBlockIndex: timeBlockIndex,
                                        dragTimeBlockRow: timeBlockRow
                                    });
                                }
                            }}
                            type={this.props.type}
                        />
                        <Events
                            parentTrackIndex={this.props.parentTrackIndex}
                            childTrackIndex={this.props.childTrackIndex}
                            events={this.props.events}
                            dragTimeBlockIndex={this.state.dragTimeBlockIndex}
                            dragTimeBlockRow={this.state.dragTimeBlockRow}
                            dragging={this.state.isDragging}
                            dragStart={(eventIndex, eventRow) => {
                                this.setState({
                                    ...this.state,
                                    isDragging: true,
                                    eventIndex: eventIndex,
                                    eventRow: eventRow
                                });
                            }}
                            movingEventIndex={this.state.eventIndex}
                            dragEnd={() => {
                                this.setState({
                                    ...this.state,
                                    isDragging: false,
                                    eventIndex: false,
                                    eventRow: false,
                                    dragTimeBlockIndex: false,
                                    dragTimeBlockRow: false
                                });
                            }}
                            showChildren={this.props.showChildren}
                        />
                    </div>
                </div>
            </TrackResizer>
        );
    }
}

export default connect(
    store => {
        return {
            weekCount: selectWeekCount(store)
        };
    },
    {}
)(Track);
